import { User } from '@apis/index'
import Button from '@components/button'
import Column from '@components/column'
import Fields from '@components/fields'
import Typography from '@components/typography'
import { AuthSchema } from '@validations'
import { Form, Formik } from 'formik'
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AuthFooter from '../component/authFooter'
import AuthHeader from '../component/authHeader'
import {
  AuthCard,
  AuthContainer,
  AuthWrapper,
  BottomSection,
  FormContainer,
  FormInputsContainer,
  FormWrapper,
} from '../style'
import GoBack from '@components/back'
const OtpPage = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)

  const { phoneNo, countryCode, purpose, token } = location?.state

  const submitHandler = async (values: any) => {
    setLoading(true)
    const payload = {
      phoneNo: phoneNo,
      otp: values.otp,
      countryCode: countryCode,
      token,
    }
    await User.verifyOtp(payload)
      .then((res) => {
        navigate('/register', {
          state: {
            ...payload,
            token: res.token,
          },
        })
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const resend = async () => {
    const payload = {
      phoneNo: phoneNo,
      purpose: purpose,
      countryCode: countryCode,
    }
    await User.requestOtp(payload)
      .then((resp) => {
        navigate('.', { state: { ...payload, token: resp.token } })
      })
      .catch(() => {})
  }
  return (
    <AuthWrapper>
      <AuthCard>
        <AuthContainer>
          <GoBack visibleForDesktop={false} />
          <AuthHeader content="Verify your" tag="OTP" />

          <Column alignItems="center" rowGap={5} styleColumn="margin:40px auto">
            <Typography
              size={12}
              content="Enter 6 digits code that we've sent to you mobile number"
            />
            <Typography
              size={12}
              content={`+${countryCode} ${phoneNo}`}
              tc={'primary'}
            />
          </Column>
          <Formik
            initialValues={{
              otp: null,
            }}
            onResend={resend}
            enableReinitialize
            validationSchema={AuthSchema.otpSendValidationSchema}
            onSubmit={submitHandler}
          >
            {({ handleSubmit }) => {
              return (
                <FormWrapper>
                  <Form onSubmit={handleSubmit}>
                    <FormContainer>
                      <FormInputsContainer>
                        <Fields.OtpInput name="otp" length={6} />
                      </FormInputsContainer>
                      <BottomSection>
                        <AuthFooter
                          content="Already have a Account ?"
                          tag="Login Now"
                          onClick={() => navigate('/login')}
                        />
                        <Button
                          title="Confirm"
                          styleButton="width:100%;margin-top:40px;"
                          height={45}
                          type="submit"
                          loading={loading}
                        />
                      </BottomSection>
                    </FormContainer>
                    <Column styleColumn="margin-top:40px" rowGap={20}></Column>
                  </Form>
                </FormWrapper>
              )
            }}
          </Formik>
        </AuthContainer>
      </AuthCard>
    </AuthWrapper>
  )
}

export default OtpPage
